export default __webpack_public_path__ + "static/media/info-icon.ef167a2a.svg";